import { Action } from '@ngrx/store';
import { IShowErrors } from '../IShowErrors';
import { ResponseStatus, IStatusMessage } from '../../../common/Interfaces';

export enum ErrorsSidenavActionTypes {
    SetErrors = '[ErrorsSidenav] SetErrors',
    SetErrorsForProcess = '[ErrorsSidenav] SetErrorsForProcess',
    RemoveErrors = '[ErrorsSidenav] RemoveErrors',
    ClearErrors = '[ErrorsSidenav] Clear Errors',
    SetShowErrors = '[ErrorsSidenav] SetShowErrors'
}

export class SetErrors implements Action {
    constructor(public payload: Array<IStatusMessage>) {
        this.payload = payload || [];
    }
    readonly type = ErrorsSidenavActionTypes.SetErrors;
}
export class RemoveErrors implements Action {
    constructor(public payload?: Array<string>) {}
    readonly type = ErrorsSidenavActionTypes.RemoveErrors;
}
export class SetErrorsForProcess implements Action {
    constructor(
        public payload: { errors: Array<IStatusMessage>; processId: number }
    ) {}
    readonly type = ErrorsSidenavActionTypes.SetErrorsForProcess;
}
export class ClearErrors implements Action {
    constructor() {}
    readonly type = ErrorsSidenavActionTypes.ClearErrors;
}
export function UnknownResponse() {
    return new SetErrors([
        {
            Message: 'An Unknown result was returned.',
            StatusCode: ResponseStatus.Failed
        }
    ]);
}

export class SetShowErrors implements Action {
    constructor(public payload: IShowErrors) {}
    readonly type = ErrorsSidenavActionTypes.SetShowErrors;
}

export type ErrorsSidenavActionsUnion =
    | SetErrors
    | SetErrorsForProcess
    | ClearErrors
    | SetShowErrors
    | RemoveErrors;
